<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpeakerOn_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16.415 4.347a.75.75 0 0 1 1.047-.169A9.687 9.687 0 0 1 21.475 12a9.682 9.682 0 0 1-4.013 7.822.75.75 0 1 1-.878-1.216A8.173 8.173 0 0 0 19.975 12a8.175 8.175 0 0 0-3.39-6.606.75.75 0 0 1-.17-1.047Zm-6.398.153a.834.834 0 0 0-.667.333L6.512 8.618l-2.737.547A2.084 2.084 0 0 0 2.1 11.208v1.584c0 .993.701 1.848 1.675 2.043l2.737.547 2.838 3.784a.833.833 0 0 0 1.5-.5V5.333a.833.833 0 0 0-.833-.833Zm4.151 2.491a.75.75 0 1 0-.637 1.359A4.056 4.056 0 0 1 15.867 12a4.057 4.057 0 0 1-2.336 3.65.75.75 0 0 0 .637 1.36 5.56 5.56 0 0 0 3.2-5.01 5.56 5.56 0 0 0-3.2-5.009Z"
        clip-rule="evenodd"
    />
</svg>
